import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    voteList: [],
    voteInfo: {},
    myVoteInfo: {
        lastUnvotedTime: 0,
        tokenNum: 0,
        votes: '--',
        producerVOS: [],
        producerVo: []
    },
    myVoteList: [],
    refundVoteList: [],

    voteAmount: '',

    filter: {
        from: 'MUSDT',
        to: 'AMAX',
        sort: 3,
    },
};

const SwapSlice = createSlice({
    name: 'vote',
    initialState,
    reducers: {
        setVoteList(state, { payload: data }) {
            const { data: list, is_frist } = data;
            state.voteList = is_frist ? list : [...state.voteList, ...list];
        },
        setVoteInfo(state, { payload: data }) {
            state.voteInfo = data;
        },
        setMyVoteInfo(state, { payload: data }) {
            console.log('setMyVoteInfo:::', data)
            state.myVoteInfo = data;
        },
        setMyVoteList(state, { payload: data }) {
            state.myVoteList = data;
        },
        setRefundVoteList(state, { payload: data }) {
            state.refundVoteList = data;
        },
        setFilter(state, { payload: data }) {
            state.filter = data;
        },
        setVoteAmount(state, { payload: amount }) {
            state.voteAmount = amount.toString();
        },
    },
});

export default SwapSlice.reducer;
